<template>
  <div class="room-type">
        <div class="d-flex justify-content-between">
            <div class="room-title">
                其他需求
            </div>
            <el-button v-if="formData.length<8" class="mr-3" icon="el-icon-plus" type="primary" size="mini" @click="submitPost()">新增</el-button>
        </div>
        <!--房型标题-->
        <ul class="other-list mt-3">
            <li v-for="(item,index) in formData" :key="index">
                <!--房间类型-->
                <el-select 
                    v-model="item.add_title"
                    :class="{ roomRed: isFieldError(index, 'add_title') }"
                    @change="getId($event,index)"
                    @blur="blurs($event,index)"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择或输入名称"
                class="w-50 ml-2"  >
                <template >
                    <el-option
                        v-for="roomItem in add_name"
                        :key="roomItem.title"
                        :label="roomItem.title"
                        :value="`${roomItem.id},${roomItem.title}`"
                    >
                    </el-option>
                    </template>
                </el-select>
                <el-input 
                placeholder="金额"
                v-model.number="item.add_price"  
                class=" ml-2 w-50 "
                @input="onFieldChange"
                :class="{ roomRed: isFieldError(index, 'add_price') }">
                type="number" >
                    <!-- <span slot="prepend">&yen;</span> -->
                    <span slot="append" class="lisxn">元</span>
                </el-input>
            <div class="w-20 deletes">
                <i class="el-icon-delete" @click="splicse(i,index)" ></i>
                <!-- <el-button  class="mt-1" type="danger" size="mini" @click="splicse(i,index)">删除</el-button> -->
            </div>
            </li>
        </ul>
  </div>
</template>

<script>
export default {
  name: 'other',
  components: {},
  props: {
    add_need: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
        formData:[],
        add_name:[{title:'会场费',id:0},{title:'餐费',id:1},{title:'其他',id:2}],
        add_needs:{add_title:'',add_price:''},
         // 错误标记：精准记录 行+子项+字段名
        isSubmit:false,
        errorMap:{},
    };
  },
  computed: {},
  watch: {
    add_need: {
      handler(newVal, oldVal) { 
        this.formData = newVal;
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    //新增一个其他需求项
    submitPost(){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.add_needs)));
        this.formData.push(data);
    },
    //删除其他需求项
    splicse(i){
        this.formData.splice(i,1)
    },
    //确认订单
    submitForm(){
        this.isSubmit = true;
        const valid = this.validateAll();
        if (!valid) {
            this.$message.error('请填写完整的其他需求信息');
            return false;
        }
        return true;
    },

    // 全局校验，逐个字段判断
    validateAll() {
    this.errorMap = {};
    let pass = true;

    this.formData.forEach((item, rowIdx) => {
        // 固定校验 5 个字段
        const fields = ['add_title', 'add_price'];

        fields.forEach(field => {
        const val = item[field];
        if (!val || String(val).trim() === '') {
            this.setFieldError(rowIdx, field);
            pass = false;
        }
        });
    });
    return pass;
    },

    // 记录错误字段：key 格式 rowIdx|field
    setFieldError(rowIdx, field) {
        const key = `${rowIdx}|${field}`;
        this.errorMap[key] = true;
    },

    // 输入时实时更新错误状态
    onFieldChange() {
        if (!this.isSubmit) return;
        this.validateAll();
    },

    // 判断单个字段是否标红
    isFieldError(rowIdx, field) {
        if (!this.isSubmit) return false;
        const key = `${rowIdx}|${field}`;
        return !!this.errorMap[key];
    },
    // 房型相关
    getId(val,index){
        let [id, name] = val.split(',');
        let room_offer={...this.formData[index],add_title:name?name:id}
        this.$set(this.formData,index,room_offer);
    },
    blurs(val,index){
        if(val.target.value){
            let room_offer={...this.formData[index],add_title:val.target.value}
            this.$set(this.formData,index,room_offer);
        }
    }
  }
};
</script>

<style lang="scss" scoped>
    .room-type{
        text-align: left;
    }
    .room-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 4px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .other-list{
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
    }
    .other-list li{
        display: flex;
        margin-bottom: 16px;
        width: 50%;
    }
    .deletes{
        text-align: center;
        display: flex;
        justify-content: center;
        color: red;
        font-size: 16px;
        margin-top: 10px;
        cursor: pointer;
        i:nth-child(1){
            margin-right: 5px;
        }
    }
</style>
<style>
    .room-type .el-date-editor.el-input{
        width: 100%;
    }
    .room-type .el-input__inner{
        text-align: center;
    }
    .room-type .el-input-group__append,.room-type .el-input--suffix .el-input__inner ,.room-type .meeting-type .el-input__inner{
        font-size: 12px;
    }
    .roomRed .el-input__inner,
    .roomRed .el-date-editor .el-input__inner {
    border-color: #F56C6C !important;
    }
</style>
